import { render, staticRenderFns } from "./BonusPointsPage.vue?vue&type=template&id=3edc7346&scoped=true&"
import script from "./BonusPointsPage.vue?vue&type=script&lang=js&"
export * from "./BonusPointsPage.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=3edc7346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc7346",
  null
  
)

export default component.exports